export default __webpack_public_path__ + "static/a62d1448-7e6b-4e3c-802a-79db9b5e2ddd-6739cbb48714320761382869ee1a5907.woff";